/*
 * EventPlannerMap
 *
 * Purpose: iterate through the available elements and add markers to the map,
 * when an origin point is provided hit up the directions API
 */
var event_planner_map_init = function() {
  evp.init_map();
};

var EventPlannerMap = function() {};
EventPlannerMap.prototype = {
  points : [],
  map_id : 'event-planner-map',
  panel_id : 'event-planner-routing-panel',
  panel_directions_id : 'event-planner-routing-panel-directions',
  default_lat: -23.033333,
  default_lng: 132.166667,
  default_region_bias : 'au',
  map : null,
  directionsService : null,
  directionsRenderer : null,
  user_position : {},// representing user_position
  init : function() {
    try {
      this.load_maps();
    } catch (e) {
      this.error('Error:' + e);
    }
  },
  log : function(msg) {
    console.log('EventPlannerMap:', msg);
  },
  error: function(msg) {
    console.warn(msg);
  },

  // load maps script asynchronously, if not already loaded
  load_maps : function() {

    // already init'd by something else
    if (typeof google === 'object' && typeof google.maps === 'object') {
      // this.log('google.maps already loaded');
      return;
    }

    var map = $('#' + this.map_id);
    if(map.length == 0) {
      // this.log('no map');
      return;
    }

    var api_key = $('#' + this.map_id).attr('data-apikey');
    if(!api_key) {
      // this.log('No API key provided');
      return;
    }

    var callback = 'event_planner_map_init';
    var mapid =  $('#' + this.map_id).data('mapid');// can be > 1, if so comma separated
    var parameters = '?'
                    + 'key=' + api_key
                    + '&callback=' + callback
                    + (mapid ? '&map_ids=' + mapid : '')
                    + '&libraries=places';

    // load up map scripts and related elements
    var googleMapScript = document.createElement('script');
    googleMapScript.setAttribute('type','text/javascript');
    googleMapScript.setAttribute('async', true);
    googleMapScript.setAttribute('src','https://maps.google.com/maps/api/js' + parameters);
    (document.getElementsByTagName('head')[0] || document.documentElement).appendChild(googleMapScript);

    // this.log('load_maps');

  },

  init_map : function() {

    var map_options = {
      zoom: 10,
      center: this.get_centre(),
      clickableIcons: false
    };

    // cloud map styling
    var mapid =  $('#' + this.map_id).data('mapid');
    if(mapid) {
      map_options.mapId = mapid;
    }

    this.map = new google.maps.Map( document.getElementById(this.map_id), map_options);

    this.set_markers();
    this.prompt_location();//events that prompt for location
    this.route_calculator();//events that handle route calculation
  },

  get_points : function(clear) {
    var _self = this;
    if(clear) {
      this.points = [];
    }
    var has_initial_route = false;
    var sel = '.event-planner-dashboard #trip-planner .event';
    $(sel).each( function() {
      var s = {
        'eid' : $(this).attr('data-id'),
        'lat' : $(this).attr('data-lat'),
        'lng' : $(this).attr('data-lng'),
        'startdate' : $(this).find('.time:first').attr('data-startdate'),
        'starttime' : $(this).find('.time:first').attr('data-starttime'),
        'enddate' : $(this).find('.time:first').attr('data-enddate'),
        'endtime' : $(this).find('.time:first').attr('data-endtime'),
        'title' :	$.trim($(this).find('.event-title:first').text()),
        'href' :	$(this).find('.event-title:first').attr('data-link')
      };
      s.htmltitle = '<a href="' + s.href  + '">' +  s.title + '</a>';
      // store the point
      _self.points.push(s);
      // ensure point is valid
      _self.check_point(s);
      // add current route to the first routable event
      if( !has_initial_route && $(this).children('button').attr('disabled') != 'disabled' ) {
        has_initial_route = true;
        $(this).addClass('current-route');
      }

    });
  },

  check_point: function(s) {
    // if date in past, the event cannot be used in a route search
    var et = s.endtime;
    var ed = s.enddate;
    var in_past = this.in_past(ed, et);
    // this.log(s.title + ' - ' + ed + 'T' + et);
    if(!et || !ed || in_past) {
      // this.log(s.title + ' is in the past');
      // mark relevant route-marker as in past
      $('.event-planner-dashboard .event[data-id="' + s.eid + '"]').addClass('in-past').find('button.route-marker').addClass('in-past').attr('disabled', 'disabled');
    }
  },

  set_markers : function() {
    var _self = this;
    this.get_points(false);
    var marker;
    var bounds = new google.maps.LatLngBounds();
    var infoWindow = new google.maps.InfoWindow();
    for(var i=0;i<this.points.length;i++) {
      // Add marker
      marker = new google.maps.Marker({
        eid : this.points[i].eid,
        map : this.map,
        title : this.points[i].title,
        href : this.points[i].href,
      });
      pos = {
        lat: parseFloat(this.points[i].lat),
        lng: parseFloat(this.points[i].lng)
      };
      marker.setPosition( pos );

      marker.addListener('click', function() {
        var pos = this.getPosition();
        var content = '<h6 class="infowindow_title">'
                      + '<a href="' + this.href + '">'
                      + this.title
                      + '</a></h6>';
        infoWindow.setContent(content);
        infoWindow.setPosition( pos );
        //infoWindow.setOptions( { pixelOffset : new google.maps.Size(0, 0) });
        infoWindow.open(_self.map, this);

        // trigger a direction finder when a marker is clicked
        $('#trip-planner .event[data-id="' + this.eid + '"] button.route-marker:not(.in-past)').trigger('click');
      });

      bounds.extend( pos );
    }

    google.maps.event.addListenerOnce(this.map, 'bounds_changed', function(event) {
      this.setZoom(_self.map.getZoom());
      if (this.getZoom() > 15) {
        this.setZoom(15);
      }
    });

    this.map.fitBounds(bounds);

  },

  get_origin : function() {
    // get origin, from an address field maybe
    return null;
  },

  empty_panel : function() {
    $('#' + this.panel_directions_id).empty();
  },

  show_panel : function(maplink) {
    $('#' + this.panel_id).removeClass('no-results').addClass('with-route');
    if(maplink) {
      $('#' + this.panel_id + ' .maplink a').attr('href', maplink);
    }
  },

  reverse_geocode : function( pos, success_callback ) {
    var _self = this;
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      {'location': pos },
      function(results, status) {
        if (status === 'OK') {
          if (results[0]) {
            var address = results[0].formatted_address;
            // _self.log('Reverse geocode success:' + address);
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            // _self.log('Reverse geocode lat:' + lat);
            // _self.log('Reverse geocode lng:' + lng);
            $('#location-current').val( address ).data( { 'lat': lat, 'lng': lng } );
            $('#location-current').data('pending', 0);

            if(typeof success_callback == 'function') {
              // _self.log('firing success_callback from reverse_geocode');
              success_callback(success_callback);
            }

            return true;
          }
        }
        // failed in some way
        _self.geocode_failover(pos);
    });
  },

  // when geocode failed, we still have a position, update for directions service
  geocode_failover : function (pos) {
    $('#location-current').data('pending', 0).val( '' ).data( {'lat': pos.lat, 'lng': pos.lng } );
  },

  // Event handler on prompter to get location when clicked
  prompt_location : function() {
    var _self = this;
    $(document).on(
      'click',
      '#event-location-prompter > .btn-location',
      function(e) {
        // mark routes for re-render
        _self.allow_routing();
        // get the location
        _self.ask_for_location(null, e);
      }
    );

    // whenever the input location is focused, clear current data props and lock the input
    $(document).on(
      'focus',
      '#location-current',
      function(e) {
        // clear previous location data
        $('#location-current').removeData(['lat','lng']);
        // lock so that geocode does not update value
        $(this).data('locked', 1);
      }
    );

  },

  // Ask the visitor for their location
  ask_for_location : function(success_callback, evt) {
    var _self = this;
    $('#location-current').data('pending', 1).data('locked', 0);
    var vl = new VisitorLocation();
    var success = function(position, map) {

      // if the location input is locked, avoid any further processing
      // as the visitor is doing something manual with the address field
      if($('#location-current').data('locked') == 1) {
        return;
      }

      var pos = {
        lat : parseFloat(position.coords.latitude),
        lng : parseFloat(position.coords.longitude)
      };

      //_self.log('call draw position');
      _self.draw_position(pos, map);

      // reverse geocode the position into the map
      // _self.log('reverse_geocode');
      _self.reverse_geocode( pos, success_callback);

    };

    /**
     * @var error GeolocationPositionError
     */
    var error = function(err, gmap) {
      _self.error(err.message);
      $('.location-alert').addClass('hidden');
      switch(err.code) {
        case 1:
          $('#location-denied-alert').removeClass('hidden').attr('data-error-code', err.code);
          break;
        case 2:
        case 3:
        default:
          $('#location-error-alert').removeClass('hidden').attr('data-error-code', err.code);
          break;
      }
    };

    var options = {
      enableHighAccuracy: true,
      timeout: 30000
    };
    var gmap_options = {};
    vl.retain_user_zoom  = true;
    vl.detect(success, error, options, _self.map, gmap_options, evt);
  },

  draw_position : function(pos, map) {
    try {
      var latLng = new google.maps.LatLng( pos.lat, pos.lng);
      if('point' in this.user_position) {
        // Only update the position of the markers
        this.user_position.point.setPosition(latLng);
        this.user_position.skirt.setPosition(latLng);
        return;
      }
      // the uncertainty circle
      var r = 30;//px
      var circle = new google.maps.Marker({
        map : map,
        clickable : false,
        position : latLng,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillOpacity: 0.1,
          fillColor : '#000000',
          strokeOpacity: 1.0,
          strokeColor : '#333333',
          strokeWeight: 0,
          scale: r
        }
      });
      var point = new google.maps.Marker({
        map : map,
        clickable : false,
        position : latLng,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          fillOpacity: 0.9,
          fillColor: '#007fc4',
          strokeOpacity: 1.0,
          strokeColor: '#ffffff',
          strokeWeight: 2.0,
          scale: Math.round(r/3)
        }
      });

      this.user_position = {
        point : point,
        skirt : circle
      };

    } catch (e) {
      console.error(e);
    }
  },

  // build a maps link for a link off to Google Maps, *addr can be anything addressy e.g lat,lng
  build_maps_link : function(origin, destination, travelMode, departureTime, arrivalTime) {
    var dirflg, saddr, daddr = '';
    switch(travelMode) {
      case 'WALKING':
        dirflg = 'w';
        break;
      case 'DRIVING':
        dirflg = 'd';//or h or t
        break;
      case 'BICYCLING':
        dirflg = 'b';
        break;
      case 'TRANSIT':
      default:
        dirflg = 'r';
        break;
    }
    if(typeof origin == 'object') {
      saddr = origin.lat + ',' + origin.lng;
    } else {
      saddr = origin;
    }
    if(typeof destination == 'object') {
      daddr = destination.lat + ',' + destination.lng;
    } else {
      daddr = destination;
    }

    // this.log('build_maps_link');
    if(departureTime) {
      // @var luxon.DateTime
      // this.log(departureTime);
      var ttype = 'dep';
      var pivot_date = departureTime.toISODate();
      var pivot_time = departureTime.toISOTime();
    } else if(arrivalTime) {
      // @var luxon.DateTime
      // this.log(arrivalTime);
      var ttype = 'arr';
      var pivot_date = arrivalTime.toISODate();
      var pivot_time = arrivalTime.toISOTime();
    }
    var maplink = 'https://maps.google.com/?'
            + 'f=d' // display mode
            + '&ttype=' + ttype // time type
            + '&date=' + encodeURIComponent(pivot_date) // departing at this date
            + '&time=' + encodeURIComponent(pivot_time) // departing at this time
            + '&saddr=' + encodeURIComponent(saddr)
            + '&daddr=' + encodeURIComponent(daddr)
            + '&dirflg=' + dirflg; // r = transit, d = driving, w=walking
    // this.log('Maplink:' + maplink);
    return maplink;
  },

  route_calculator : function() {
    var _self = this;

    // one renderer per load
    this.directionsRenderer = new google.maps.DirectionsRenderer;
    this.directionsRenderer.setMap(this.map);
    this.directionsRenderer.setPanel( document.getElementById( this.panel_directions_id ) );
    /*
    this.directionsRenderer.setOptions({
      //preserveViewport: true,
      //suppressInfoWindows: true
    });
    */

    // this event  can be triggered from anywhere e.g geocode after location retrieval
    $(document).on(
      'dorouting',
      '#' + this.map_id,
      function() {
        // get the current destination
        var dest = $('#trip-planner .event.current-route');
        var rendered = dest.data('rendered');
        if(rendered) {
          return;
        }
        dest.data('rendered', true);// set this route as rendered
        // trigger rendering of the route using the destination button
        //_self.log('dorouting');
        //_self.log(dest);
        _self.trigger_render_leg(dest);
      }
    );

    // clicking on a destination can trigger a routing
    $(document).on(
      'click',
      '#trip-planner button.route-marker:not(.in-past)', // only those events not in the past can trigger this event
      function(ev) {

        // allow routing on whatever button was clicked
        _self.allow_routing();

        // call the routing event handler
        _self.routing_event_handler();

        // set this as current-route
        $(this).parent().addClass('current-route').siblings().removeClass('current-route');

        // if mobile, scroll to
        if($('a.btn-directions').is(':visible')) {
          try {
            document.getElementById('event-planner-map-holder').scrollIntoView();
          } catch (e) {
            _self.error(e);
          }
        }
      }
    );

    // form submission triggers routing
    $(document).on(
      'submit',
      '#trip-planner',
      function(ev) {
        ev.preventDefault();
        // mark routes for re-render
        _self.allow_routing();
        // call the routing event handler
        _self.routing_event_handler();
        return false;
      }
    );

    // trigger a render_leg when the radio for travel mode changes
    $(document).on(
      'change',
      '#trip-planner .travelmode input',
      function() {
        // _self.log('travelmode change');
        // when transit mode changes, routing should be re-rendered
        _self.allow_routing();
        // call the routing event handler
        _self.routing_event_handler();
      }
    );
  },

  // allow routing to take place on all destinations
  allow_routing : function() {
    $('#trip-planner .event').data('rendered', false);
  },

  // trigger routing on current route button
  routing_event_handler : function() {
    $('#' + this.map_id).trigger('dorouting');
  },

  // check location input for a valid geolocation
  valid_current_location : function() {
    var lat = $('#location-current').data('lat');
    var lng = $('#location-current').data('lng');
    return !(lat === '' || lng === '' || lat == undefined || lng == undefined);
  },

  // trigger a directions request, using the element passed in as the destination
  trigger_render_leg : function(to) {
    var _self = this;
    // the render callback
    var render = function(to) {

      // at this point the locaton-current should have data
      if(!_self.valid_current_location()) {
        // .. but do not proceed
        throw 'No valid current location';
      }
      var from_point = {
        lat : $('#location-current').data('lat'),
        lng : $('#location-current').data('lng'),
        origin : $('#location-current').val(),
      };

      var to_point = {
        lat : parseFloat(to.attr('data-lat')),
        lng : parseFloat(to.attr('data-lng')),
        origin : to.find('address').text(),
      };

      //_self.log(to_point);

      var to_point_time = to.find('.time:first');
      var to_point_startdate = to_point_time.attr('data-startdate');
      var to_point_starttime = to_point_time.attr('data-starttime');
      if(to_point_startdate  && to_point_starttime) {
        to_point.startdate = to_point_startdate;
        to_point.starttime = to_point_starttime;
      }

      from_point.title = from_point.origin;
      to_point.title = to_point.origin;

      try {
        _self.render_leg(from_point, to_point);
        return true;
      } catch (e) {
        _self.error('Failed:' + e);
      }
      return false;
    };

    if(this.valid_current_location()) {
      render(to);
    } else {
      this.ask_for_location(
        function() {
          render(to);
        }
      );
    }
  },

  get_centre : function() {
    var e = $('#' + this.map_id);
    var lat = e.data('lat');
    var lng = e.data('lng');
    if(lat === '' && lng === '') {
      lat = this.default_lat;
      lng = this.default_lng;
    } else {
      lat = parseFloat(lat);
      lng = parseFloat(lng);
    }
    var centre = new google.maps.LatLng(lat, lng);
    return centre;
  },

  centre_map : function() {
    this.map.setCenter( this.get_centre() );
  },

  trigger_resize : function() {
    google.maps.event.trigger(this.map, 'resize');
  },

  default_tz : function() {
    var tz = $('#' + this.map_id).data('tz');
    if(!tz) {
      tz = 'UTC';
    }
    return tz;
  },

  in_past : function(date, time, tz) {
    if(!tz) {
      tz = this.default_tz();
    }
    var cd = this.current_date(tz);
    // this.log('inpast date:' + date);
    // this.log('inpast time:' + time);
    // this.log('inpast tz:' + tz);
    var d = this.create_date(date, time, tz);
    var in_past = d < cd;
    // this.log('inpast:' + (in_past ? 'yes' : 'no'));
    return in_past;
  },

  // @return luxon.DateTime
  current_date : function(tz) {
    if(!tz) {
      tz = this.default_tz();
    }
    // this.log('current_date: tz=' + tz);
    var d = luxon.DateTime.now().setZone(tz);
    // this.log(d);
    return d;
  },

  // @return luxon.DateTime
  create_date : function(date, time, tz) {
    if(!tz) {
      tz = this.default_tz();
    }
    // this.log('create_date: tz=' + tz);
    var dt = date + 'T' + time;
    // this.log('ISO:' + dt);
    var d = luxon.DateTime.fromISO(dt).setZone(tz);
    // this.log(d);
    return d;
  },

  // ensure only one of the four available modes is provided
  // note: certain transit modes may return zero results if checking too far in future
  get_travelmode : function() {
    var mode = $('#trip-planner .travelmode input:checked').val();
    var defaultmode = 'TRANSIT';
    switch(mode) {
      case 'TRANSIT':
      case 'WALKING':
      case 'BICYCLING':
      case 'DRIVING':
        return mode;
        break;
      default:
        $('#trip-planner .travelmode input[value="' + defaultmode + '"]').attr('checked','checked');
        return defaultmode;
    }
  },

  // use the DirectionsService to render a single trip
  render_leg : function(from_point, to_point) {

    var _self = this;
    var origin, destination, arrivalTime, departureTime;

    // create a new DirectionsRenderer to render the results
    var directionsService = new google.maps.DirectionsService;

    if(!to_point) {
      throw 'No destination point available';
      return false;
    }

    if(from_point.lat && from_point.lng) {
      origin = { lat: parseFloat(from_point.lat), lng: parseFloat(from_point.lng) };
    } else {
      origin = from_point.origin;
    }

    if(!origin) {
      throw 'No origin point available';
      return false;
    }

    // if on or before the event start date/time, arrivalTime is set to the startdate/time of event, departureTime is not set
    // if after the event start date/time, departureTime is now, arrivalTime is not set
    // if after the event has ended, shouldn't even be rendering a leg
    if(this.in_past(to_point.startdate, to_point.starttime)) {
      // event has already started, better leave now!
      // @var luxon.DateTime
      departureTime = this.current_date();
      arrivalTime = null;
    } else {
      // in the future
      departureTime = null;
      // @var luxon.DateTime
      arrivalTime = this.create_date(to_point.startdate, to_point.starttime);
    }

    //this.log('From ' + from_point.title + ' To ' + to_point.title);

    if(to_point.lat && to_point.lng) {
      destination = { lat: parseFloat(to_point.lat), lng: parseFloat(to_point.lng) };
    } else {
      destination = to_point.origin;
    }

    var options = {
      origin: origin,
      region : this.default_region_bias,
      provideRouteAlternatives : true,
      travelMode: this.get_travelmode()
    };

    if(!destination) {
      throw 'No destination available';
    }

    options.destination = destination;

    switch(options.travelMode) {
        case 'TRANSIT':
          options.transitOptions = {
            modes: ['BUS', 'RAIL','TRAIN','TRAM'],
            routingPreference: 'FEWER_TRANSFERS',
          };
          if(arrivalTime) {
            // docs: The departureTime will be ignored if arrivalTime is specified
            options.transitOptions.arrivalTime = arrivalTime.toJSDate();
          } else if(departureTime) {
            // docs: if arrivalTime is specified, departureTime is ignored
            options.transitOptions.departureTime = departureTime.toJSDate();
          }
          break;
        case 'DRIVING':
          /*
          // Premium?
          options.drivingOptions = {
            trafficModel: 'bestguess'
          };
          if(departureTime) {
            options.drivingOptions.departureTime = departureTime.toJSDate;
          }
          */
          break;
    }

    // this.log('render_leg');
    // this.log( options );

    // empty the panel holder we'll be creating one route per leg
    this.empty_panel();
    // set a map link for this route
    maplink = this.build_maps_link( options.origin, options.destination, options.travelMode, departureTime, arrivalTime );
    var callback = function(response, status) {
      switch(status) {
        case 'OK':
          $('#' + _self.panel_directions_id).addClass('no-results');
          _self.show_panel(maplink);
          _self.directionsRenderer.setDirections({routes: []});// clear previous directions
          _self.directionsRenderer.setDirections(response);
          return true;
          break;
        default:
          $('#' + _self.panel_id).addClass('no-results');
          _self.directionsRenderer.setDirections({routes: []});// clear previous directions
          _self.log('Request failed due to ' + status);
          return false;
          break;
      }
    };
    directionsService.route(options, callback);

  }

};


var evp = new EventPlannerMap();
(function($){
    "use strict";
    $(document).ready(
      function() {
        evp.init();
        // when visible
        $(document).on(
          'click',
          'a.btn-directions',
          function(e) {
            e.preventDefault();
            try {
              document.getElementById('event-planner-routing-panel').scrollIntoView();
            } catch(e) {}
          }
        );
      }
    );
}(jQuery));
